import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import {betStore, gameConfigStore, LoadingContainer} from "@pascal/pascal-core";
import {doBetsStore} from "../store";
import {AppDefaultValuesEnum} from "../constants";

export const Factory = ({ children }) => {

    const repliedCallback = () => {
        const { repliedBetData } = betStore;
        gameConfigStore.setLimits(repliedBetData.replayData.limits);
        doBetsStore.setBetAmount(
            repliedBetData.additionalParams.markets[repliedBetData.additionalParams.markets.length - 1].amount
        );
    };
  return (
    <BrowserRouter>
      <LoadingContainer appDefaultValuesEnum={AppDefaultValuesEnum} gameSpecificRepliedCallback={repliedCallback}>{children}</LoadingContainer>
    </BrowserRouter>
  );
};
